import { number, string, object } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

const toNullableAmount = (value, originalValue) => {
  if (originalValue === '' || originalValue === null || originalValue === undefined) {
    return null
  }
  return value
}

export const getValidationSchema = ({ useCrudValidationMessages = false } = {}) => {
  const blankMessage = useCrudValidationMessages
    ? I18n.t('publisher.event_type_editor_crud.payments.validation.amount_blank')
    : I18n.t('errors.messages.blank')
  const minMessage = useCrudValidationMessages
    ? I18n.t('publisher.event_type_editor_crud.payments.validation.amount_min')
    : I18n.t('errors.messages.cannot_be_less_than', { count: '0.50' })
  const maxMessage = I18n.t('errors.messages.less_than', { count: 100000 })
  const notANumberMessage = I18n.t('errors.messages.not_a_number')

  return object({
    provider: string(),
    lastValidProvider: string().nullable(),
    currency: string().nullable(),
    amount: number().nullable().when('provider', {
      is: (provider) => provider !== 'none',
      then: number()
        .nullable()
        .transform(toNullableAmount)
        .typeError(notANumberMessage)
        .required(blankMessage)
        .min(0.5, minMessage)
        .max(99999.99, maxMessage)
    }),
    paymentTerms: string().max(1024, I18n.t('errors.messages.too_long', { count: 1024 })),
  })
}
